import { NotFoundPageLabels } from 'libs/shared-lib/interfaces/partner-web/not-found-page';

export const NOT_FOUND_LABELS_FR: NotFoundPageLabels = {
    headline: '404',
    copy: "La page que vous recherchez n'est plus disponible.",
    ctaPostText: 'Continuer à',
};
